import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const setAIProviderDisabledSchema = z.object({
  id: z.string(),
  disabled: z.boolean(),
});

export const setAIProviderDisabled = mutator({
  schema: setAIProviderDisabledSchema,
  resolve: {
    provider: { kind: "aiProvider", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { provider, disabled } }) => {
    if (disabled && provider.active) {
      throw userFacingError(
        "Set another AI provider as the default before disabling this one"
      );
    }
    const now = Date.now();
    await tx.mutate.aiProviders.update({
      id: provider.id,
      disabledAt: disabled ? now : null,
      updatedAt: now,
    });
  },
});
